import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomizedSelectoption from "../General/CustomizedSelectoption";
import {
  partyDisplayName,
  refresh_AccDeCrParty,
  setAccDeCr_party,
  setDebCrdDeafult,
  setDebCrdVenType,
} from "../features/Accounts";
import { API_FETCH, API_POST, DecryptData } from "../General/Utility";
// same voucher-number setting popup the web Debit Note uses (check the path in the POS project)
import VouchernoSetting from "../Setting/VoucherNo";

function DebitCreditBody(props) {
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);
  const _AccParem = useSelector((state) => state.Accounts.DebitCredit);
  const _TabParem = useSelector((state) => state.Accounts.DebCrdTab);
  const _HTParem = useSelector((state) => state.Accounts.DebCrdHT);
  const _Selectparem = useSelector((state) => state.SelectOption.parems);
  const [arrVendore, setarrVendore] = useState([]);
  const [isVouchNoSett, setisVouchNoSett] = useState(false);
  // every vendor search gets a number; only the LATEST one may fill the list,
  // so a slow older response can never overwrite a newer one
  const searchReq = useRef(0);

  const iVenType = Number(_AccParem.iVenTypeId) || 0;
  // Vendor Type 6 (Manual Invoice) has no party
  const isNoParty = iVenType === 6;
  // a cancelled voucher is read-only
  const isLocked = !!_AccParem.isCancel;
  // Voucher No is typed by the user only when the number format is set to Manual
  // (web screen: disabled={!isManualNo}). A saved note keeps its number: the
  // save procedure does not update DebNo.
  const objFmt = (_HTParem.arrNoFormat || [])[0] || {};
  const isManualNo =
    objFmt.isManualNumber === true ||
    objFmt.isManualNumber === 1 ||
    String(objFmt.isManualNumber).toLowerCase() === "true";
  const isRemarkRequired = (_HTParem.arrValidation || []).some(
    (v) => v.strCtrlName === "txtRemark" && v.isValidate === true
  );
  const lockStyle = isLocked ? { pointerEvents: "none", opacity: 0.6 } : {};

  // Redux Admin can be empty right after a page refresh, so fall back to the
  // encrypted values in localStorage.
  const sessionParams = async () => {
    const local = (await DecryptData(localStorage.jbctrlparams)) || {};
    return {
      Branch: Number(_AuthParems.Branch || local.Branch),
      DB: _AuthParems.DB || local.DB,
    };
  };

  // The vendor list always follows the selected Vendor Type. Before this fix
  // it was loaded only once, so opening a Supplier voucher from the list
  // showed an empty Vendor Name (the list still held Customers).
  useEffect(() => {
    if (!Number(_AccParem.iScrId)) return; // screen not loaded yet
    View_AllVendores(iVenType, "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iVenType, _AccParem.iScrId, _AuthParems.DB]);

  const View_AllVendores = async (VenType, strtext) => {
    const iType = Number(VenType);
    if (!iType || iType === 6) {
      searchReq.current += 1;
      setarrVendore([]);
      return;
    }
    let strcolname = "";
    let ScrId = 0;
    switch (iType) {
      case 4:
        ScrId = 2;
        strcolname = "CustName";
        break;
      case 5:
        ScrId = 50;
        strcolname = "VenName";
        break;
      default:
        ScrId = 3;
        strcolname = "SuppName";
        break;
    }
    const reqId = ++searchReq.current;
    const session = await sessionParams();
    const parems = {
      iScrId: ScrId,
      iPartyId: iType,
      strColName: strcolname,
      strSearch: strtext,
      strDBName: session.DB,
      iBranchId: session.Branch,
    };
    const res = await API_POST(`PartyTrans/Search_Party`, parems, dispatch);
    if (reqId !== searchReq.current) return; // a newer search has started
    if (res) {
      setarrVendore(res.EntParty || []);
    }
  };

  // Keep the selected vendor visible even when it is not in the searched list
  const arrVendoreView = useMemo(() => {
    const id = Number(_AccParem.iVenId) || 0;
    if (id > 0 && !arrVendore.some((p) => Number(p.partyId) === id)) {
      const name = partyDisplayName(_AccParem.strVenName);
      if (name) return [{ partyId: id, partyName: name }, ...arrVendore];
    }
    return arrVendore;
  }, [arrVendore, _AccParem.iVenId, _AccParem.strVenName]);

  const View_Party = async (iVenId) => {
    const id = Number(iVenId) || 0;
    if (id === 0) return;
    const session = await sessionParams();
    const res = await API_FETCH(
      `${props.PartyUrl}${iVenType}/${id}/${session.Branch}/${session.DB}`,
      dispatch
    );
    if (res) {
      const objFound = arrVendore.find((p) => Number(p.partyId) === id);
      const strName =
        partyDisplayName((res.objEntParty || [])[0]) ||
        partyDisplayName(objFound);
      dispatch(
        setAccDeCr_party({
          strVenName: strName,
          iVenId: id,
        })
      );
    }
  };

  // Change ONE field and keep everything else as it is
  const Input_OnChange = (strField, val) => {
    dispatch(setDebCrdDeafult({ ..._AccParem, [strField]: val }));
  };

  // Debit Note passes KeyDown, older screens pass TabIndex: accept both
  const handleKey = (e) => {
    const fn = props.KeyDown || props.TabIndex;
    if (typeof fn === "function") fn(e);
  };

  return (
    <div className="container p-2">
      <div className="row">
        {isLocked && (
          <div className="col-12 mt-1">
            <span
              style={{
                display: "inline-block",
                padding: "2px 12px",
                borderRadius: "4px",
                border: "1px solid #b42318",
                color: "#b42318",
                fontWeight: 600,
                letterSpacing: "1px",
              }}
            >
              CANCELLED
            </span>
          </div>
        )}
        <div className="col-md-3 col-sm-6 mt-1">
          <label>
            Voucher No <span className="danger">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Voucher Number"
            value={_AccParem.strVouchNo || ""}
            tabIndex={_TabParem.VoucherTab}
            onKeyDown={handleKey}
            maxLength={50}
            readOnly={!isManualNo || isLocked || Number(_AccParem.iDebCrdId) > 0}
            onChange={(e) => Input_OnChange("strVouchNo", e.target.value)}
          />
          <span
            className="inv-no"
            onClick={() => setisVouchNoSett(true)}
          >
            <i className="bx bx-cog"></i>
          </span>
        </div>
        <div className="col-md-3 col-sm-6 mt-1">
          <label>
            Trans No <span className="danger">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            tabIndex={_TabParem.TransNoTab}
            onKeyDown={handleKey}
            readOnly
            value={_AccParem.strTransNo || ""}
          />
        </div>
        <div className="col-md-3 col-sm-6 mt-1">
          <label>
            Date <span className="danger">*</span>
          </label>
          <input
            type="date"
            name="strVouchDate"
            tabIndex={_TabParem.VouchDateTap}
            onKeyDown={handleKey}
            className="form-control"
            value={_AccParem.strVouchDate || ""}
            disabled={isLocked}
            onChange={(e) => Input_OnChange("strVouchDate", e.target.value)}
          />
        </div>
        <div className="col-md-3 col-sm-6 mt-1" style={lockStyle}>
          <label>
            Vendor Type <span className="danger">*</span>
          </label>
          <CustomizedSelectoption
            optionparem="isoptionShow"
            showoption={_Selectparem.isoptionShow}
            placeholder="Select Vendor Type"
            taborder={_TabParem.VenTypeTab}
            keydown={(e) => handleKey(e)}
            select_value={(val) => {
              // FIX: refresh_AccDeCrParty used to wipe the whole voucher
              // (voucher no, date, branch, ids). Now only the party is
              // cleared. The vendor list reloads by itself (useEffect).
              dispatch(refresh_AccDeCrParty());
              dispatch(setDebCrdVenType(val));
            }}
            btnname="Vendor"
            btnshow={false}
            show_popup=""
            valueonly={true}
            defaultval={_AccParem.iVenTypeId}
            displayName="strVenTypeName"
            disvalue="iVenTypeId"
            arrydata={_HTParem.arrVenType}
            EmptVal="Vendor Type "
          />
        </div>
        <div
          className="col-md-6 col-sm-12 mt-1"
          style={isLocked || isNoParty || !iVenType ? { pointerEvents: "none", opacity: 0.6 } : {}}
        >
          <label>
            Vendor Name {!isNoParty && <span className="danger">*</span>}
          </label>
          <CustomizedSelectoption
            optionparem="isoptionShow1"
            showoption={_Selectparem.isoptionShow1}
            placeholder="Select Vendor"
            taborder={_TabParem.VenNameTab}
            keydown={(e) => handleKey(e)}
            onChange={(val) => View_AllVendores(iVenType, val)}
            select_value={(val) => View_Party(val)}
            btnname="Vendor"
            btnshow={false}
            show_popup=""
            valueonly={true}
            defaultval={_AccParem.iVenId}
            displayName="partyName"
            disvalue="partyId"
            arrydata={arrVendoreView}
            EmptVal="Vendor "
          />
        </div>
        <div className="col-md-3 col-sm-6 mt-1">
          <label>
            Amount<span className="danger">*</span>
          </label>
          <input
            type="number"
            min="0"
            step="0.01"
            inputMode="decimal"
            className="form-control"
            tabIndex={_TabParem.AmountTab}
            onKeyDown={(e) => {
              // no exponent / sign characters in an amount
              if (["e", "E", "+", "-"].includes(e.key)) {
                e.preventDefault();
                return;
              }
              handleKey(e);
            }}
            onWheel={(e) => e.target.blur()}
            style={{ textAlign: "right" }}
            value={_AccParem.dAmount}
            disabled={isLocked}
            onClick={(e) => e.target.select()}
            onChange={(e) => {
              const v = e.target.value;
              // digits with at most 2 decimals
              if (v === "" || /^\d{0,10}(\.\d{0,2})?$/.test(v)) {
                Input_OnChange("dAmount", v);
              }
            }}
            onBlur={(e) => {
              const n = Number(e.target.value);
              const strFixed = n > 0 ? n.toFixed(2) : (0).toFixed(2);
              if (strFixed !== e.target.value) Input_OnChange("dAmount", strFixed);
            }}
          />
        </div>
        <div className="col-md-4 col-sm-6 mt-1">
          <label>
            Remarks {isRemarkRequired && <span className="danger">*</span>}
          </label>
          <textarea
            style={{ height: "100px" }}
            className="form-control rounded"
            placeholder="Enter Remarks"
            tabIndex={_TabParem.Remarktab}
            onKeyDown={(e) => {
              // Shift+Enter = new line, Enter = next field
              if (e.key === "Enter") {
                if (e.shiftKey) return;
                e.preventDefault();
              }
              handleKey(e);
            }}
            value={_AccParem.strRemark || ""}
            disabled={isLocked}
            onChange={(e) => Input_OnChange("strRemark", e.target.value)}
          ></textarea>
        </div>
      </div>
      {isVouchNoSett && (
        <VouchernoSetting
          iScrId={Number(_AccParem.iScrId) || 43}
          Close={() => {
            setisVouchNoSett(false);
            if (typeof props.onVoucherSettingClose === "function")
              props.onVoucherSettingClose();
          }}
        />
      )}
    </div>
  );
}

export default DebitCreditBody;